// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".type-select-modal-img{object-fit:contain;height:158px;width:158px;margin:auto}.type-select-modal-link{text-decoration:underline;color:inherit}.modal-add-to-cart{width:100%;border-radius:0 !important}.type-select-modal-row{align-items:center}", ""]);
// Exports
module.exports = exports;
